<div [ngClass]="{ 'sidebar': true, 'collapsed': collapsed, 'bg-dark': themeService.isDarkMode$ | async }">
  <!-- Brand Logo -->
  <div class="sidebar-brand d-flex align-items-center gap-2 mb-4 mt-2 px-3">
    <div class="brand-avatar">IN</div>
    <div class="brand-text d-flex flex-column" [class.d-none]="collapsed">
      <span class="brand-name">insizon</span>
      <span class="brand-role">{{ role === 'Admin' ? 'Admin Panel' : 'User Panel' }}</span>
    </div>
  </div>

  <div class="sidebar-section-label px-4 mb-2 text-muted fw-bold" [class.d-none]="collapsed">
    <small>WORKSPACE</small>
  </div>

  <div class="sidebar-menu px-2 mb-5">
    <a *ngFor="let item of sidebarItems"
       (click)="navigate(item)"
       [ngClass]="{
         'sidebar-item': true,
         'active': isActive(item.route),
         'disabled': item.isDisabled
       }"
       class="d-flex align-items-center gap-3 p-2 mb-1 rounded text-decoration-none">
      <i *ngIf="item.icon" [ngClass]="item.icon" style="color: #84806f;"></i>
      <span [class.d-none]="collapsed" class="text-truncate" style="color: #e0e0e0 !important;">{{ item.label }}</span>
    </a>
  </div>
</div>